export function getSpectraObjectPaths(spectra, keys = ['display', 'meta', 'info', 'customInfo']) {
    const paths = {};
    for (const spectrum of spectra) {
        for (const key of keys) {
            lookForObjectsPaths(spectrum[key], [key], paths);
        }
    }
    return { datalist: Object.keys(paths), paths };
}
function lookForObjectsPaths(obj, path, output) {
    if (['string', 'number', 'boolean'].includes(typeof obj)) {
        const key = path.join('.');
        output[key] = path;
        path = [];
    }
    else {
        for (const key in obj) {
            lookForObjectsPaths(obj[key], [...path.slice(), key], output);
        }
    }
}
